import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textarea-input" }

import { PropType, ref } from "vue";
import { Uuid } from "@/code/Uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTextAreaInput',
  props: {
  type: {
    type: String,
    default: "text",
  },
  name: String,
  value: String,
  placeholder: String,
  modelValue: String,
  disabled: Boolean,
  label: {
    type: String,
    required: true,
  },
  rules: {
    type: Object as PropType<object | string>,
    required: false,
  },
  id: {
    type: String,
    required: false,
    default: Uuid.newUuid(),
  },
  maxlength: {
    type: Number,
    required: false,
  },
},
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props, { emit }) {

const props = __props;


const active = ref<boolean>(!!props.modelValue);

const id = ref<string>(props.id);
const onInput = (event: Event) => {
  const targetEl = event.target as HTMLInputElement;
  emit("update:modelValue", targetEl.value);
};
const onFocus = (event: Event) => {
  active.value = true;
  emit("focus", (event.target as HTMLInputElement).value);
};
const onBlur = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  if (!value) {
    active.value = false;
  }
  emit("blur", value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_field, {
      id: id.value,
      disabled: __props.disabled,
      label: __props.label,
      name: __props.name,
      rules: __props.rules,
      validateOnBlur: true,
      validateOnChange: false,
      validateOnInput: false,
      validateOnModelUpdate: false,
      as: "textarea",
      onBlur: onBlur,
      onFocus: onFocus,
      onInput: onInput,
      maxLength: __props.maxlength
    }, null, 8, ["id", "disabled", "label", "name", "rules", "maxLength"])
  ]))
}
}

})